import React from 'react';

interface Redirection {
  toPath: string;
}

export function useScheduledRedirect(scheduleDate: Date, redirection: Redirection) {
  React.useEffect(() => {
    if (!window.location) {
      return;
    }

    console.log(scheduleDate, new Date(), scheduleDate < new Date());
    if (scheduleDate <= new Date()) {
      if (/^https?/.test(redirection.toPath)) {
        window.location.href = redirection.toPath + window.location.search;
      } else if (/^\/(.*)/.test(redirection.toPath)) {
        window.location.pathname = redirection.toPath;
      }
    }
  }, [scheduleDate, redirection]);
}
